/**
 * SkillRow — JSX copied verbatim from
 * designs/edit-with-ai-combined-6-9.html lines 152-167.
 *
 * Renders a single skill in the sidebar and bottom sheet. Shows icon
 * square + name + description, with either a "tool" badge (skills that
 * invoke external tools) or a pinned star in the trailing slot.
 */

import type { SkillListItem } from '../../types/skills';

export interface SkillRowProps {
  s: SkillListItem;
  /** Optional — future skill types may surface the 'tool' badge. */
  hasToolBadge?: boolean;
  onClick: () => void;
}

export function SkillRow({ s, hasToolBadge = false, onClick }: SkillRowProps) {
  const isPinned = (s as SkillListItem & { isPinned?: boolean }).isPinned ?? false;
  return (
    <button
      onClick={onClick}
      className="w-full text-left px-2 py-1.5 rounded-md hover:bg-white dark:hover:bg-nightshade-800 transition-colors flex items-center gap-2"
    >
      <span className="w-6 h-6 flex items-center justify-center bg-nightshade-100 dark:bg-nightshade-800 rounded text-sm">
        {s.icon ?? '⚡'}
      </span>
      <div className="flex-1 min-w-0">
        <div className="text-xs font-medium text-nightshade-900 dark:text-nightshade-100 truncate">{s.name}</div>
        <div className="text-[10px] text-nightshade-500 dark:text-nightshade-400 truncate">{s.description}</div>
      </div>
      {hasToolBadge && (
        <span className="text-[9px] px-1 py-0.5 bg-tangerine-100 text-tangerine-700 dark:bg-tangerine-900/40 dark:text-tangerine-400 rounded">
          tool
        </span>
      )}
      {!hasToolBadge && isPinned && (
        <span className="text-[10px] text-lemon-400 dark:text-lemon-300" title="Pinned">
          ★
        </span>
      )}
    </button>
  );
}

